@if(sessionDetails && sessionDetails.sessionId && showNavbar){
<nav-bar></nav-bar>
}
<div class="crc-main-container">
  <router-outlet></router-outlet>
</div>

@if(showHeaderFooter) {
<div class="customer-footer-bar" [class.hide-on-mobile]="hideFooterOnMobile">
  <app-footer></app-footer>
</div>
}